import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const SectionHeader = ({ title, subtitle, light = false, centered = true }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <Box
      ref={ref}
      sx={{
        mb: 6,
        width: '100%',
        textAlign: centered ? 'center' : 'left',
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
        transition={{ duration: 0.6 }}
      >
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontWeight: 600,
            mb: 2,
            color: light ? 'white' : 'primary.main',
          }}
        >
          {title}
        </Typography>

        <Divider
          sx={{
            width: centered ? '80px' : '60px',
            height: '4px',
            backgroundColor: 'secondary.main',
            mx: centered ? 'auto' : 0,
            mb: 3,
          }}
        />

        {subtitle && (
          <Typography
            variant="h6"
            sx={{
              maxWidth: '800px',
              mx: centered ? 'auto' : 0,
              color: light ? 'rgba(255, 255, 255, 0.9)' : 'text.secondary',
              lineHeight: 1.6,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </motion.div>
    </Box>
  );
};

export default SectionHeader; 